import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateDossierInsuranceController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierInsuranceController.php
* @route '/api/dossier/update-insurance/{dossier}'
*/
const UpdateDossierInsuranceController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierInsuranceController.url(args, options),
    method: 'put',
})

UpdateDossierInsuranceController.definition = {
    methods: ["put"],
    url: '/api/dossier/update-insurance/{dossier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierInsuranceController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierInsuranceController.php
* @route '/api/dossier/update-insurance/{dossier}'
*/
UpdateDossierInsuranceController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierInsuranceController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierInsuranceController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierInsuranceController.php
* @route '/api/dossier/update-insurance/{dossier}'
*/
UpdateDossierInsuranceController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierInsuranceController.url(args, options),
    method: 'put',
})

export default UpdateDossierInsuranceController